// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-0a3aa910]{text-transform:capitalize}.poster[data-v-0a3aa910]{height:132px;max-height:132px;width:88px;border-radius:8px;margin-inline-end:8px}", ""]);
// Exports
module.exports = exports;
